<template>
    <div class="section-group" :class="{ fullwidth: fullwidth }">
        <label :for="fieldName">{{ title }}</label>

        <input :type="fieldType" :id="fieldName" :name="fieldName" :readonly="readonly" :value="value" @input="$emit('input', $event.target.value)" />
    </div>
</template>

<script>
// Example Usage:
// <dealer-agreement-form-field title="Title" fieldName="field" />

export default {
    name: 'dealer-agreement-form-field',

    props: {
        fieldType: {
            type: String,
            required: false,
            default: 'text',
        },

        title: {
            type: String,
            required: true,
        },

        fieldName: {
            type: String,
            required: true,
        },

        fullwidth: {
            type: Boolean,
            default: false,
        },

        readonly: {
            type: Boolean,
            default: true,
        },

        value: {
            type: [String, Number],
            required: false,
            default: '',
        },
    },
};
</script>
